import axios from "@/api/axios";

class UserService {
  async getUsers(params = {}) {
    return await axios.get("/users", { params });
  }

  async getUser(id) {
    return await axios.get(`/users/${id}`);
  }

  async createUser(data) {
    return await axios.post("/users", data);
  }

  async updateUser(id, data) {
    return await axios.put(`/users/${id}`, data);
  }

  async deleteUser(id) {
    return await axios.delete(`/users/${id}`);
  }
  async assignRoles(id, roles) {
    return await axios.post(`/users/${id}/assign-roles`, { roles });
  }
  async toggleActive(id) {
    return await axios.post(`/users/${id}/toggle-active`);
  }
  async toggleVerification(id) {
    return await axios.post(`/users/${id}/toggle-verification`);
  }
  async togglePremium(id) {
    return await axios.post(`/users/${id}/toggle-premium`);
  }
  async updateOwnerProfileStatus(id, data) {
    return await axios.post(`/owners/${id}/update-status`, data);
  }

  async registerOwner(data) {
    return await axios.post("/owners", data);
  }

  async getOwners(params = {}) {
    return await axios.get("/owners", { params });
  }

  async updateOwnerProfile(id, data) {
    return await axios.put(`/owners/${id}`, data);
  }

  async assignModerator(moderatorId, userIds) {
    return await axios.post("/users/assign-moderator", {
      moderator_id: moderatorId,
      user_ids: userIds,
    });
  }

  async getFollowUpUpdates(id, params = {}) {
    return await axios.get(`/users/${id}/follow-up/updates`, { params });
  }

  async addFollowUp(id, payload) {
    return await axios.post(`/users/${id}/follow-up`, payload);
  }
}

export default new UserService();
